import React from 'react';
import { TextField } from '@material-ui/core';
import { withFormsy } from 'formsy-react';
import _ from '@lodash';

function TextFieldFormsy(props) {
	const importedProps = _.pick(props, [
		'autoComplete',
		'autoFocus',
		'children',
		'className',
		'defaultValue',
		'disabled',
		'FormHelperTextProps',
		'fullWidth',
		'id',
		'InputLabelProps',
		'inputProps',
		'InputProps',
		'inputRef',
		'label',
		'multiline',
		'name',
		'onBlur',
		'onChange',
		'onFocus',
		'onKeyPress',
		'placeholder',
		'required',
		'minRows',
		'rowsMax',
		'select',
		'SelectProps',
		'style',
		'type',
		'variant',
		'aria-owns',
		'aria-haspopup',
		'onMouseEnter',
		'onMouseLeave'
	]);

	const errorMessage = props.errorMessage;
	const value = props.value || '';

	function changeValue(event) {
		props.setValue(event.currentTarget.value);
		if (props.onChange) {
			props.onChange(event);
		}
	}

	const hasError = Boolean(errorMessage);

	return (
		<TextField
			{...importedProps}
			onChange={changeValue}
			value={value}
			error={hasError}
			helperText={errorMessage || props.helperText}
			inputProps={{
				...importedProps.inputProps,
				'aria-invalid': hasError,
				...(hasError && importedProps.id ? { 'aria-errormessage': `${importedProps.id}-helper-text` } : {})
			}}
			FormHelperTextProps={{
				...importedProps.FormHelperTextProps,
				...(hasError && importedProps.id ? { id: `${importedProps.id}-helper-text` } : {})
			}}
		/>
	);
}

export default React.memo(withFormsy(TextFieldFormsy));
